module.exports = __webpack_public_path__ + "img/trans.0cbf1c33.jpg";